import Validator from 'validator'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import _includes from 'lodash/includes'

let validationArray = []

export const hasErrors = () => {
  let hasErrors = _includes(validationArray, false)
  validationArray = []
  return hasErrors;
}

export const PresentOf = (input) => {
  if (isEmpty(input)) {
    validationArray.push(false)
    return  "Can't be blank";
  }
  return null;
}

export const DateFormatOf = (input) => {
  let currentDate = moment(input, 'DD.MM.YYYY', true);

  if( ! currentDate.isValid() ) {
    validationArray.push(false)
    return  "Invalid";
  }
  return null;
}

export const SelectOf = (input, array) => {
  let values = array.map( x => x[0] )

  if ( ! _includes(values, input) ) {
    validationArray.push(false)
    return  "Can't be blank";
  }
  return null;
}

export const AcceptanceOf = (input) => {
  if ( ! input ) {
    validationArray.push(false)
    return "Must be accepted";
  }
  return null;
}

export const EmailOf = (input) => {
  if ( ! Validator.isEmail(input) ) {
    validationArray.push(false)
    return "Email is not valid";
  }
  return null;
}

export const NumberOf = (input, size) => {
  let regex = /^\d+$/

  if ( ! regex.test(input) || parseInt(input, 0) <= 0) {
    validationArray.push(false)
    return "Must be accepted";
  }

  if ( size !== undefined && input.length < size ) {
    validationArray.push(false)
    return "Must be accepted";
  }
  return null;
}

export const PresentAndDigitOf = (input) => {
  // should not be empty
  // should contains 1 digit

  if (isEmpty(input) || ! input.match(/\d+/g) ) {
    validationArray.push(false)
    return  "Can't be blank";
  }
  return null;
}
